'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';

import Why from '@/components/home-page/whySection';
import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';
import Image from "next/image";



const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/Maintenance.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    Maintenance & Support
  </h1>
    
  </div>

  <NavBar />

  <section className="about-me-copy  bg-secondary">
          <div className="about-me-copy-wrapper">
            <h2 className='text-primary text-3xl lg:text-6xl py-8'>
              Launch day isn't the finish line, it's the start. We keep your
              site secure, fast, and up to date, so you can focus on your
              business while we handle the rest.
            </h2>

          </div>
        </section>

        <section className="services">
 <div className="services-col">
  <div className="services-banner">
    <Image
      src="/hero/support.avif"
      alt=""
      fill
      style={{ objectFit: "cover" }}
      sizes="(max-width: 768px) 100vw, 50vw"
    />
  </div>
</div>
          <div className="services-col ">
            <h4 className='text-2xl lg:text-3xl'>
              Every website needs care after launch. We provide proactive
              monitoring and fast, reliable support, so small issues never
              become big problems.
            </h4>

            <div className="services-list">
              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Ongoing Maintenance</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We handle regular updates, dependency management, and
                    performance tuning to keep your site running smoothly as
                    technology evolves.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Security Monitoring</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We continuously monitor your application for
                    vulnerabilities and threats, applying patches quickly to
                    keep your site and your users' data safe.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Priority Technical Support</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    When issues come up, our team responds fast — fixing
                    bugs, resolving downtime, and answering questions so you
                    always have support you can rely on.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

<Why/>
<ContactForm/>

<FAQContainer
  title={"Maintenance &\nSupport FAQs"}
  description="Answers to the most common questions clients ask about our maintenance plans, support process, and what's covered after launch."
  faq={[
    {
      question: "What does your maintenance service include?",
      answer:
        "Our maintenance service covers regular updates, security monitoring, bug fixes, performance optimization, and ongoing technical support.",
    },
    {
      question: "Do you offer subscription-based maintenance plans?",
      answer:
        "Yes, we offer yearly subscription plans that bundle maintenance, support, and updates at a fixed annual fee for predictable, worry-free coverage.",
    },
    {
      question: "How quickly do you respond to issues?",
      answer:
        "We prioritize urgent issues and aim to respond quickly, with response times depending on your support plan and the severity of the issue.",
    },
    {
      question: "Can you maintain a site you didn't originally build?",
      answer:
        "Yes, we regularly take over maintenance for existing sites and applications built by other teams, after a quick technical review.",
    },
    {
      question: "Do you monitor for security vulnerabilities?",
      answer:
        "Absolutely. We continuously monitor for vulnerabilities and apply security patches promptly to keep your site and data protected.",
    },
    {
      question: "What happens if my site goes down?",
      answer:
        "We treat downtime as a priority issue and work quickly to identify the cause and restore your site, keeping you informed throughout.",
    },
  ]}
/>
<Footer/>
</>
  );
};

export default ContactForms;